import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';

/** Retains old bookmarks while moving all labor pricing into Workforce Finance. */
@Component({ standalone: true, template: '' })
export class FieldWorkLaborRatesRedirectComponent implements OnInit {
  private readonly router = inject(Router);

  ngOnInit(): void {
    void this.router.navigate(['/accounts/enterprise/workforce-finance'], {
      queryParams: { tab: 'RATE_CARDS' },
      replaceUrl: true
    });
  }
}
